import {css} from "@emotion/css";
import {gql, useQuery, useApolloClient, ApolloClient} from "@apollo/client";



export async function queryMasterToken(client: ApolloClient<any>, tokenId: number) {
  const response = await client.query({
    variables: {
      id: `${tokenId}-Master`
    },
    query: gql`
      query Piece($id: ID!) {
          tokenMaster(id: $id) {
              id,
              tokenDetails {
                  tokenId,
                  uri,
              }
              layerCount,
              layers {
                  tokenDetails {
                      tokenId,
                  }
                  numControlLevers,
                  numRemainingUpdates,
                  numberOfUpdates,
                  levers {
                      id,
                      numberOfUpdates,
                      minValue,
                      maxValue,
                      currentValue,
                      previousValue
                  }
              }
          }
      }
  `
  });
  return response.data?.tokenMaster;
}


export function ArtworkBrowser(props: {
  onSelect: (master: any) => void
}) {
  const {data, loading, error} = useQuery(gql`
    query Piece {
      masters: tokenMasters(first: 300) {
          id,
          tokenDetails {
            tokenId,
            uri,
          }
          layerCount,
          layers {
            tokenDetails {
                tokenId,
            }
            numControlLevers,
            numRemainingUpdates,
            numberOfUpdates,
            levers {
              id,
              numberOfUpdates,
              minValue,
              maxValue,
              currentValue,
              previousValue
            }
          }
      }
    }
  `, {
  });

  const handleSelect = (e: any, master: any) => {
    e.preventDefault();
    props.onSelect(master);
  };

  return <div className={css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    padding: 20px;
  `}>
    {loading ? "Loading..." : null}
    {error ? JSON.stringify(error) : null}
    {data ? <div className={css`
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    `}>
      {data.masters.map((master: any) => {
        return <a className={css`
          width: 100px;
          height: 50px;
          background-color: red;
          margin: 10px;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
        `} href="" onClick={(e) => handleSelect(e, master)}>
          {master.tokenDetails.tokenId}
        </a>
      })}
    </div> : null}
  </div>
}